<div class="box card-box"
     [attr.test-id]="descriptor?.groupZoneID"
     [class.card-has-errors]="group?.invalid"
     [class.dated]="descriptor?.isDated"
     [class.disabled]="readOnly">
  <div class="box-header">
    <h3>{{ descriptor?.transId | translate }}</h3>
    <div class="card-dated-controls pull-right no-padding" [attr.data-hidden]="readOnly">
      <button type="button"
              class="btn white no-borders"
              tooltip="{{ 'TOOLTIPS.add_entry' | translate }}"
              placement="left"
              (click)="addEntity()">
        <i class="fa fa-light fa-plus" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="box-body table-responsive">
    <ul class="error-list" *ngIf="group?.invalid && errorMessages?.length">
      <li *ngFor="let error of errorMessages">
        {{ 'FORM_GENERATOR.ERRORS.' + error.text | translate: error.additionalValues }}
      </li>
    </ul>
    <gp-table class="table" [fixedLayout]="false" [class.disabled]="readOnly" (sortChange)="onSortKeyChange($event)" #table>
      <thead gp-table-head>
      <tr role="row">
        <th class="text-center text-muted small text-left" style="width:22px;" *ngIf="descriptor.groupZoneKeyName">
          &nbsp;
        </th>
        <ng-container *ngFor="let zone of descriptor.zones">
          <th *ngIf="!zone.hidden" class="text-center column-title text-muted small text-left"
              gp-table-column sort-key="{{descriptor.groupZoneKeyName ? null : zone.zoneID}}">
            {{ zone.transId | translate }}{{ zone?.isRequired ? ' *' : '' }}
            <gp-form-field-mapping-indicators *ngIf="!isOnBoarding && employee?.id" [descriptor]="zone"></gp-form-field-mapping-indicators>
          </th>
        </ng-container>
        <th class="text-center text-muted small text-left" gp-table-column
            default-sort="desc" sort-key="{{descriptor.groupZoneKeyName ? null : 'begindate'}}"
            *ngIf="descriptor.isDated">
          {{ 'FORMS.begin_date' | translate }}
        </th>
        <th class="text-center text-muted small text-left"
            gp-table-column sort-key="{{descriptor.groupZoneKeyName ? null : 'enddate'}}"
            *ngIf="descriptor.isDated">
          {{ 'FORMS.end_date' | translate }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr #tableRowsContainer></tr>
      </tbody>
    </gp-table>
  </div>
</div>

<gp-blocking-error-resolution-modal
  *ngIf="newBlockingErrors && newBlockingErrors.length"
  [blockingErrors]="newBlockingErrors"
  [zoneDescriptor]="lastFieldFocused?.descriptor"
  [groupZoneDescriptor]="descriptor"
  (onCancelChange)="cancelChange($event)"
  (onBackToEditMode)="backToEditMode($event)"
></gp-blocking-error-resolution-modal>
